import React from 'react';
import { getActiveLanguage, getTranslate } from 'react-localize-redux';
import { connect } from 'react-redux';
import './ServiceTable.css';
import TaskListItem from './TaskListItem';

class TaskTable extends React.Component {
  columnsCount = () => {
    const { session: { isAdmin = false } } = this.props;
    return isAdmin
      ? 12
      : 9;
  };

  renderHeader = () => {
    const { translate, session: { isAdmin = false } } = this.props;

    return (
      <thead>
        <tr className="report-table-header_service">
          {isAdmin && (
            <th className="report-table-th_worklist">{translate('service_report.column_task.user')}</th>
          )}
          <th className="report-table-th_worklist">{translate('service_report.column_task.date')}</th>
          <th className="report-table-th_worklist">{translate('service_report.column_task.customer')}</th>
          <th className="report-table-th_worklist">{translate('service_report.column_task.end_customer')}</th>
          <th className="report-table-th_worklist">{translate('service_report.column_task.address')}</th>
          <th className="report-table-th_worklist">{translate('service_report.column_task.city')}</th>
          <th className="report-table-th_worklist">{translate('service_report.column_task.service_site')}</th>
          <th className="report-table-th_worklist">{translate('service_report.column_task.service')}</th>
          <th className="report-table-th_worklist">{translate('service_report.column_task.feature')}</th>
          {isAdmin && (
            <th className="report-table-th_worklist">{translate('service_report.column_task.duration')}</th>
          )}
          {isAdmin && (
            <th className="report-table-th_worklist">{translate('service_report.column_task.billed')}</th>
          )}
        </tr>
      </thead>
    );
  };

  renderLoadingInfo = () => {
    const { translate, isLoading } = this.props;
    return isLoading
      ? (
        <tr className="report-table-row_worklist">
          <td colSpan={this.columnsCount()}
              className="report-table-cell_service_no_border">
            {translate('service_report.search.loading')}
          </td>
        </tr>
      )
      : null;
  };

  renderResult = () => {
    const {
      translate,
      data,
      isLoading,
      currentLanguage,
      session: { isAdmin = false },
    } = this.props;
    if (isLoading) {
      return null;
    }

    const viewData = data.length > 0
      ? data.slice()
      : [];

    const totalSum = (viewData.length && viewData.length > 0)
      ? viewData.reduce((prev, curr) => Number(curr.invoicePrice) + prev, 0)
      : 0;

    return (
      <React.Fragment>
        {viewData.length === 0 && (
          <tr>
            <td colSpan={this.columnsCount()}>
              {translate('service_report.search.no_data_found')}
            </td>
          </tr>
        )}

        {viewData.map((task) => (
          <TaskListItem key={task.taskId}
                        item={task}
                        currentLanguage={currentLanguage}
                        isAdmin={isAdmin} />
        ))}

        {totalSum > 0 && (
          <tr>
            <td colSpan={this.columnsCount()}>
              {translate('service_report.column_task.total_amount')}: {totalSum.toFixed(2)} €
            </td>
          </tr>
        )}
      </React.Fragment>
    );
  };

  render() {
    return (
      <div>
        <table className="report-table_service">
          {this.renderHeader()}
          <tbody>
            {this.renderLoadingInfo()}
            {this.renderResult()}
          </tbody>
        </table>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  currentLanguage: getActiveLanguage(state.locale).code,
  translate: getTranslate(state.locale),
  session: state.session,
});

export default connect(
  mapStateToProps,
  null,
)(TaskTable);



// WEBPACK FOOTER //
// ./src/components/servicereport/TaskTable.js